module.exports = __webpack_public_path__ + "img/phoneBanner.d7639042.png";